<template>
  <div>
    <div class="button" @click="setSearchVisible(true)">
      <a-icon type="search" style="font-size: 18px" />
      <div>搜索地址</div>
    </div>

    <a-modal
      title="搜索地址"
      :visible="searchVisible"
      @cancel="cancel"
      :footer="null"
    >
      <a-input-search
        placeholder="请输入地标名称"
        enter-button
        @search="search"
        :loading="loading"
      />
      <div class="list" v-if="list.length > 0">
        <div
          class="left item"
          v-for="item in list"
          :key="item.name + item.address"
        >
          <div>
            <div class="name">{{ item.name }}</div>
            <div class="address">{{ item.address }}</div>
          </div>
          <a class="link" href="#" @click.prevent="route(item)">跳转</a>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  computed: {
    ...mapState("mapTools", ["searchVisible"]),
  },
  methods: {
    ...mapMutations("mapTools", ["setSearchVisible", "setSearchLocation"]),

    cancel() {
      this.setSearchLocation({});
      this.setSearchVisible(false);
    },
    search(value) {
      if (value) {
        this.loading = true;
        fetch(
          `https://adm.ac.cn/api/gis/searchKeyword?token=njszy&keyword=枣阳市${value}&cnt=20`
        )
          .then((res) => res.json())
          .then((res) => {
            if (res && Array.isArray(res.info)) {
              if (res.info.length > 0) {
                this.list = res.info;
              } else {
                this.$message.error("搜索不到结果，请重新输入");
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$message.error("请输入兴趣点、河道、湖泊、道路或路口等地标名称");
      }
    },
    route(item) {
      this.setSearchLocation({
        lng: parseFloat(item.lng),
        lat: parseFloat(item.lat),
      });
      this.setSearchVisible(false);
    },
  },
};
</script>

<style lang="less" scoped>
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #999;
  font-size: 12px;
}

.list {
  height: 400px;
  overflow-y: auto;
  margin-top: 12px;

  .item {
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 8px;
    padding-bottom: 8px;

    .name {
      font-weight: bold;
      margin-bottom: 6px;
    }
    .address {
      color: #999;
      font-size: 12px;
    }
    .link {
      margin-left: auto;
    }
  }
}
</style>